@if ((facade.hasCryptoSavingsPlanSelected$ | async) && !(customerStateFacade.customerBaseData$ | async)?.hasActiveWallet) {
  <div class="row">
    <div class="col-12">
      <div class="mb-4 border-attention">
        <div class="pl-3 pr-3 pt-3 pb-2">
          <div class="font-medium text-size-xlarge" data-zid="no-wallet-warning">
            {{ 'trade.create.check-experience-and-ftg.showNoWalletWarning.headline' | transloco }}
          </div>
        </div>
        <div class="pl-3 pr-3 text-size-large">
          <div class="row">
            <div class="col-12 mb-3">
              {{ 'trade.create.check-experience-and-ftg.showNoWalletWarning.text' | transloco }}
              <a class="link-secondary cursor-pointer" (click)="noWalletWarningClick.emit()">{{
                'trade.create.check-experience-and-ftg.showNoWalletWarning.link' | transloco
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
